import { render } from "./BaseHeaderNav.vue?vue&type=template&id=0f1da696&scoped=true"
import script from "./BaseHeaderNav.vue?vue&type=script&lang=js"
export * from "./BaseHeaderNav.vue?vue&type=script&lang=js"

import "./BaseHeaderNav.vue?vue&type=style&index=0&id=0f1da696&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1da696"]])

export default __exports__